import { render } from "./ContentMessage.vue?vue&type=template&id=49fd0dbc"
import script from "./ContentMessage.vue?vue&type=script&lang=js"
export * from "./ContentMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__